export default __webpack_public_path__ + "components/weather-icon/static/daylightsnow-3b1d9df6ea96b4d23638bb2885f11c74.svg";